<template>
    <scalar-input-group
        v-model="relatiesoort"
        :items="availableRelatiesoorten"
        :schema="props.schema"
    >
        <template #label>
            <flex-container :gap="Size.sm">
                <input-label>
                    <slot name="label">
                        Welk relatiesoort wil je opvolgen?
                    </slot>
                </input-label>

                <span v-tooltip.info="props.tooltip">
                    <svg-icon
                        :icon="IconCircleInfo"
                        :size="IconSize.sm"
                        is-custom-icon
                    />
                </span>
            </flex-container>
        </template>

        <template #input>
            <select-input :items="availableRelatiesoorten" />
        </template>
    </scalar-input-group>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
        IconSize,
        InputLabel,
        Size,
        SvgIcon,
    } from '@keyvue/one-ui';

    import { computed, ref, watch } from 'vue';
    import { object } from 'yup';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';
    import ScalarInputGroup from '@/shared/components/ScalarInputGroup.vue';

    interface Props {
        modelValue: string | null;
        tooltip?: string;
        placeholder?: string;
        schema?: any;
    }

    const props = withDefaults(defineProps<Props>(), {
        tooltip: 'Welk relatiesoort wil je opvolgen?',
        placeholder: 'Selecteer relatiesoort',
        schema: () => object().required(),
    });

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string | null): void;
    }>();

    const relatiesoort = ref(props.modelValue);

    const availableRelatiesoorten = computed(() => ([
        {
            label: 'Bedrijf',
            value: 'BEDRIJF',
        },
        {
            label: 'Contactpersoon',
            value: 'CONTACTPERSOON',
        },
        {
            label: 'Particulier',
            value: 'PARTICULIER',
        },
        {
            label: 'Medewerker',
            value: 'MEDEWERKER',
        },
    ]));

    watch(relatiesoort, () => {
        emit('update:modelValue', relatiesoort.value);
    });

    watch(() => props.modelValue, () => {
        relatiesoort.value = props.modelValue;
    });
</script>
